import {
  ColoredAvatar,
  ColoredAvatarProps,
} from 'src/components/ColoredAvatar/colored-avatar';
import { getPlatformUserAvatarUrl } from 'src/graphql/entities/platform-user/platform-user-avatar-url';

export type PlatformUserAvatarProps = {
  partnerId: string | number | null | undefined;
  avatarFileKey: string | null | undefined;
} & Omit<ColoredAvatarProps, 'imageUrl'>;

export const PlatformUserAvatar = ({
  partnerId,
  avatarFileKey,
  ...rest
}: PlatformUserAvatarProps) => (
  <ColoredAvatar {...rest} imageUrl={getPlatformUserAvatarUrl(partnerId, avatarFileKey)} />
);

PlatformUserAvatar.displayName = 'PlatformUserAvatar';
